export default __webpack_public_path__ + "img/0dd25f817e591058e58d40833968b0ef.png";